// components/sidebar/Sidebar.jsx
import "./Sidebar.css";
import { SidebarData } from "./SidebarData";
import { ImMenu, ImUser, ImExit } from "react-icons/im";
import { useContext, useEffect, useRef, useState } from "react";
import { SidebarContext } from "../../context/SidebarContext";
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function Sidebar() {
  const { isResponsive, setIsResponsive } = useContext(SidebarContext);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login", { replace: true });
    } finally {
      setShowProfileMenu(false);
    }
  };

  return (
    <div className={`Sidebar ${isResponsive ? "Sidebar-Responsive" : ""}`}>
      <div className="Menu" onClick={() => setIsResponsive(!isResponsive)}>
        <ImMenu />
      </div>
      <ul className="SidebarList">
        {SidebarData.map((item, index) => (
          <li
            key={index}
            className={`row ${location.pathname === item.link ? "active" : ""}`}
          >
            <Link to={item.link}>
              <div id="icon">{item.icon}</div>
              <div id="title">{item.title}</div>
            </Link>
          </li>
        ))}
      </ul>

      <div className="SidebarProfile" ref={profileRef}>
        <button
          type="button"
          className="SidebarProfileBtn"
          onClick={() => setShowProfileMenu((v) => !v)}
        >
          <div id="icon">
            <ImUser />
          </div>
          <div id="title">Profil</div>
        </button>

        {showProfileMenu && (
          <div className="SidebarProfileMenu">
            <button type="button" onClick={handleLogout} className="SidebarProfileMenuLogout">
              <ImExit />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
